import React from 'react';
import { TABLE_HEADER_INDEX } from '../../constans/statisticsTableConstants';
import { Line } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-moment';
import NoResult from '../uiComponents/NoResult';
import autoColors from 'chartjs-plugin-autocolors';
import './StatisticsChart.scss';

const StatisticsChart = () => {
  Chart.register(...registerables, autoColors);

  const { filteredTableContent } = useSelector((state) => state.statisticsTable);

  const dataTableToChartData = (data) => {
    const chartContent = data.reduce((currentValue, currentRow) => {
      const currentDiscipline = currentRow[TABLE_HEADER_INDEX['DISCIPLINE']];
      const currentModel = currentRow[TABLE_HEADER_INDEX['MODEL']];
      const currentLod = currentRow[TABLE_HEADER_INDEX['LOD']];

      const currentGrade = currentRow[TABLE_HEADER_INDEX['GRADE']];
      const currentDate = currentRow[TABLE_HEADER_INDEX['DATE_CHECK']];

      const currentValueKey = `${currentDiscipline}.${currentModel}.${currentLod}`;

      if (currentValue[currentValueKey]) {
        currentValue[currentValueKey] = [...currentValue[currentValueKey], [currentDate, currentGrade]];
      } else {
        currentValue[currentValueKey] = [[currentDate, currentGrade]];
      }

      return currentValue;
    }, {});

    const dataSet = [];

    for (const chartContentKey in chartContent) {
      dataSet.push({
        xAxisID: 'x',
        yAxisID: 'y',
        label: chartContentKey,
        data: chartContent[chartContentKey],
      });
    }

    return dataSet;
  };

  const dataSet = dataTableToChartData(filteredTableContent);

  if (dataSet?.length <= 0) {
    return <NoResult />;
  }

  const options = {
    responsive: true,
    scales: {
      x: {
        grid: {
          drawTicks: true,
          lineWidth: 0,
        },
        ticks: {
          color: '#63666A',
        },
        type: 'time',
        time: {
          tooltipFormat: 'DD.MM.YYYY',
          unit: 'day',
          stepSize: 1,
        },
      },
      y: {
        max: 100,
        ticks: {
          stepSize: 15,
          color: '#63666A',
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipContext) {
            return tooltipContext.dataset.label;
          },
        },
      },
      legend: {
        display: true,
      },
      autoColors: {
        mode: 'dataset',
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className={'statistics-chart__wrapper'}>
      <Line
        options={options}
        datasetIdKey='id'
        data={{
          datasets: dataSet,
        }}
      />
    </div>
  );
};

export default StatisticsChart;
